/** @jsx jsx */
import { jsx } from "theme-ui"
import { Link, useStaticQuery, graphql } from "gatsby"

const query = graphql`
  query logoQuery {
    site {
      siteMetadata {
        siteTitle: title
      }
    }
  }
`

const Logo = props => {
  const { site } = useStaticQuery(query)
  const { siteTitle } = site.siteMetadata

  return (
    <div className="site-logo">
      <Link to="/" sx={logoStyles.logo}>
        {siteTitle}
      </Link>
    </div>
  )
}

export default Logo

const logoStyles = {
  logo: {
    display: "block",
    fontSize: "3rem",
    fontWeight: "400",
    borderBottom: "1px solid #5C2941",
    transform: "rotate(-10deg)",
    fontFamily: "var(--font-family-cursive)",
    color:'#5C2941',
    textShadow: '1px 1px #fff',
  },
}
